/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCancel200,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCancel400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCancel401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCancel500,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCancelPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCancelQueryResponse,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidCancel.ts";
import { courseRegistrationCancelEnrollmentDataViewModelSchema } from "../courseRegistrationCancelEnrollmentDataViewModelSchema.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidCancelPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidCancelPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidCancel200Schema =
  z.lazy(
    () => courseRegistrationCancelEnrollmentDataViewModelSchema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidCancel200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidCancel400Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidCancel400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidCancel401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidCancel401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidCancel500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidCancel500>;

export const getApiV1CourseregistrationEnrollmentCourseregistrationidCancelQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationEnrollmentCourseregistrationidCancel200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidCancelQueryResponse>;
